import React, { Fragment, useEffect } from 'react';
import { LmsHeader } from './lmsheader';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import Sidebar from './lms/Sidebar';
import { useAppDispatch, useAppSelector } from '../store/hook';
import { getLmsLists, selectLmsLists } from '../store/features/lmsSlice';
import ScrollToTop from './layout/ScrollToTop';
import Popup from './modal/Popup';
import { PopupCategory } from '../constants/types/popup-type';
import { getLmsLink } from '../store/features/lmsLinkSlice';
import { openAlert } from '../store/features/modalSlice';
import { isEndDateToday } from '../api/utils/util-func';

const LmsLayout = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const queryParams = useParams();

  const classId = queryParams.id ? queryParams.id : queryParams.classId;

  const lmsLists = useAppSelector(selectLmsLists);

  // 이용 기간이 만료된 클래스는 LMS 페이지 접근 차단 → 클래스 관리로 이동
  // (남은 날이 음수/0 이면서 종료일 당일도 아닌 경우)
  useEffect(() => {
    if (!lmsLists || lmsLists.id !== classId) return;

    const remainDays = Number(lmsLists.remain_days);
    const isExpired =
      lmsLists.remain_days == null ||
      Number.isNaN(remainDays) ||
      (remainDays <= 0 && !isEndDateToday(lmsLists.end_date));

    if (isExpired) {
      dispatch(
        openAlert({
          message:
            '클래스 이용 기간이 종료되었습니다.\n기간을 연장한 후 이용해주세요.',
        }),
      );
      navigate('/ClassManagement', { replace: true });
    }
  }, [lmsLists, classId, dispatch, navigate]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const lmsLists = await dispatch(
          getLmsLists({ url: `/v1/class/${classId}` }),
        ).unwrap();

        const courseId = lmsLists.course.id;

        if (courseId) {
          await dispatch(
            getLmsLink({ url: `/v1/lms-links/${courseId}` }),
          ).unwrap();
        }
      } catch (error) {}
    };
    fetchData();
  }, [classId]);

  return (
    <Fragment>
      <Popup categoryId={PopupCategory.LMS} />
      {/*
        헤더는 화면에 고정된 레이아웃 요소라 팝업(z-9999 ~ z-10002)보다 아래에 있어야 한다.
        모바일에서는 헤더가 140px 로 높아서, 위에 있으면 화면을 꽉 채운 팝업의 윗부분을 가린다.
      */}
      <div className="fixed left-0 top-0 z-[9000] mx-auto w-full px-0">
        <LmsHeader classId={classId} />
      </div>
      <main className="mt-[140px] xl:mt-[60px]">
        <div className="flex min-w-0 bg-gray1">
          <div className="hidden h-[calc(100vh-60px)] w-[250px] shrink-0 overflow-y-auto overflow-x-hidden bg-gray2 xl:block">
            {/* <div className="hidden overflow-y-auto overflow-x-hidden bg-gray2 xl:block xl:min-w-[210px]"> */}
            <Sidebar classId={classId} />
          </div>
          {/* <div className="flex bg-gray1"> */}
          {/* <div className="mx-auto flex w-full max-w-[1920px] bg-gray1"> */}
          <div className="min-w-0 flex-1 bg-gray1">
            <div className="mx-auto w-full max-w-[1920px]">
              <ScrollToTop>
                <Outlet />
              </ScrollToTop>
            </div>
          </div>
        </div>
      </main>
    </Fragment>
  );
};

export default LmsLayout;
